import GreaterLessThanEasy from "../../components/ClassOne/Mathematics/GreaterLessThanEasy";
import GreaterLessThanMedium from "../../components/ClassOne/Mathematics/GreaterLessThanMedium";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/greater-less-than/easy", title: "Easy", component: GreaterLessThanEasy },
    { url: "/class-one/mathematics/greater-less-than/medium", title: "Medium", component: GreaterLessThanMedium }
];

export default topics;